<script setup>
const minSearchStrLen = 3
const searchStr = ref('')

const show = defineModel('show')
const emit = defineEmits(['search'])


const disabledSearchBtn = computed(() => searchStr.value.length < minSearchStrLen)

function onSubmit(event) {
  event.preventDefault()
  doSearch()
}

function closeSearchBar() {
  show.value = false
  searchStr.value = ''
}

async function doSearch() {
  if (disabledSearchBtn.value) return

  emit('search', searchStr.value)
}

watch(() => show.value, (value) => {
  if (value) {
    setTimeout(() => {
      document.getElementById('searchInput').focus()
    }, 200)
  }
})
</script>

<template>
  <Transition>
    <div v-show="show" class="flex justify-center">
      <form @submit.prevent="onSubmit" class="search-bar flex items-center justify-between gap-2 mx-4 my-3 w-full md:w-[50%]">
        <InputText
          id="searchInput"
          v-model.trim="searchStr"
          class="search-input flex-grow !text-teal-600"
          maxlength="60"
          type="search"
          @keydown.escape="closeSearchBar"
          placeholder=""
        />
        <button
          type="submit"
          class="flex items-center p-2 text-teal-600 cursor-pointer"
          :disabled="disabledSearchBtn"
        >
          <i class="pi pi-search" style="font-size: 1rem; background: #363330; color: #dcd6ce;  border-radius: 0.3rem; padding: 0.5rem"/>
        </button>
      </form>
    </div>
  </Transition>
</template>
